var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lista-servicios-titulo{\r\n    color: #ffffff;\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.lista-servicios-items{\r\n    color: #f3c629;\r\n    font-weight: bolder;\r\n    font-size: 1rem;\r\n    list-style-type:decimal;\r\n}\r\n\r\n.texto-lista{\r\n    color: #ffffff;\r\n}\r\n\r\n.imagenMono{\r\n    background-image: url(" + escape(require("../../../assets/images/servicios1.png")) + ");    \r\n    background-repeat: no-repeat;\r\n    background-position-x: 30%;       \r\n    background-size: auto;\r\n}\r\n\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/servicios/servicios.component.css
// module id = ../../../../../src/app/componentes/servicios/servicios.component.css
// module chunks = 1